<template>
  <b-sidebar
    id="add-new-titulo-sidebar"
    :visible="isAddNewTituloSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetForm"
    @change="(val) => $emit('update:is-add-new-titulo-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          Adicionar novo Título
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />

      </div>

      <!-- BODY -->
      <validation-observer
        #default="{ handleSubmit }"
        ref="refFormObserver"
      >
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >             
        
          <!-- Numero do Titulo -->
          <validation-provider
            #default="validationContext"
            name="Numero do Titulo"
            rules="required"
          >
            <b-form-group
              label="Número do Título"
              label-for="numero_titulo"
            >
              <b-form-input
                id="numero_titulo"
                v-model="tituloData.numero_titulo"
                autofocus
                :state="getValidationState(validationContext)"
                trim
                placeholder="102030"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Vencimento -->
          <validation-provider
            #default="validationContext"
            name="Vencimento"
            rules="required"
          >
            <b-form-group
              label="Vencimento"
              label-for="vencimento"
            >
              <b-form-input
                id="valor"
                type="date"
                v-model="tituloData.vencimento"
                :state="getValidationState(validationContext)"                
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Valor -->
          <validation-provider
            #default="validationContext"
            name="Valor"
            rules="required"
          >
            <b-form-group
              label="Valor"
              label-for="valor"
            >
              <b-input-group prepend="R$">
                <b-form-input
                  id="valor"
                  v-model="tituloData.valor"
                  :state="getValidationState(validationContext)"
                  trim
                />
              </b-input-group>

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group> 
          </validation-provider>

          <!-- Referencia -->
          <validation-provider
            #default="validationContext"
            name="Referencia"
            rules=""
          >
            <b-form-group
              label="Referência"
              label-for="referencia"
            >
              <b-form-input
                id="referencia"
                v-model="tituloData.referencia"
                :state="getValidationState(validationContext)"
                trim
                placeholder=""
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Situação -->
          <validation-provider
            #default="validationContext"
            name="Situacao"
            rules="required"
          >
            <b-form-group
              label="Situacação"
              label-for="situacao"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="tituloData.situacao"
                :options="situacaoOptions"
                :reduce="val => val.value"
                :clearable="false"
                input-id="situacao"
                state="false"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
                
          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
            >
              Adicionar
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hide"
            >
              Cancelar
            </b-button>
          </div>

        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton, BInputGroup
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { ref } from '@vue/composition-api'
import { required, alphaNum, email } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import store from '@/store'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    BInputGroup,
    vSelect,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewTituloSidebarActive',
    event: 'update:is-add-new-titulo-sidebar-active',
  },
  props: {
    isAddNewTituloSidebarActive: {
      type: Boolean,
      required: true,
    },
    situacaoOptions: {
      type: Array,
      required: true,
    }
  },
  data() {
    return {
      required,
      alphaNum,
      email
    }
  },
  setup(props, { emit }) {
    const blankTituloData = {
      numero_titulo: '',
      vencimento: null,
      valor: '',
      referencia: '',
      situacao: null,
      cliente_id: 1
    }

    const tituloData = ref(JSON.parse(JSON.stringify(blankTituloData)))
    const resetTituloData = () => {
      tituloData.value = JSON.parse(JSON.stringify(blankTituloData))
    }

    const onSubmit = () => {
      store.dispatch('app-titulo/addTitulo', tituloData.value)
        .then(() => {
          emit('refetch-data')
          emit('update:is-add-new-titulo-sidebar-active', false)
        })
    }

    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetTituloData)

    return {
      tituloData,
      onSubmit,

      refFormObserver,
      getValidationState,
      resetForm,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
